import { Box, Typography } from "@mui/material";
import { CommonStyle, ReusableCTUI } from "Components";
import {
  PatientInitialStateType,
  ScreenInitialStateType,
  UserInitialStateType,
} from "DataTypes/Redux";
import { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import CarePlanApi from "Service/CarePlan.api";
import {
  setFormLoader,
  setRightHead,
  setTimerStatus
} from "Redux/Screen/Action";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import PatientFormatter from "Utils/Patient.Formatter";
import Stages from "Constant/Stages";
import { RouteUrls } from "Constant/RouteUrls";
import { addSelectedPrgm } from "Redux/Patient/Action";

const CareTeam: FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { selectedPrgm }: PatientInitialStateType = useSelector(
    (state: any) => state?.patient
  );
  const { myInfo }: UserInitialStateType = useSelector(
    (state: any) => state?.user
  );
  const isAdmin = myInfo.roleId == 1 || myInfo.roleId == 2
  const {
    rightHead: { timerStatus },
  }: ScreenInitialStateType = useSelector((state: any) => state?.screen);
  const currentStage = selectedPrgm.careplanStage;
  const quesStage = PatientFormatter.GetCPStage(Stages.CPQues);
  const teamStage = PatientFormatter.GetCPStage(Stages.CPTeam);
  const shareStage = PatientFormatter.GetCPStage(Stages.CPShare);
  const editCareTeam =
    (!selectedPrgm.readOnlyArr.some((el) => el == "care-team")) &&
    currentStage > quesStage;
  const addProvider =
    (!selectedPrgm.readOnlyArr.some((el) => el == "add-provider")) &&
    currentStage > quesStage;
  const editProvider =
    (!selectedPrgm.readOnlyArr.some((el) => el == "edit-provider")) &&
    currentStage > quesStage;
  const saveNextBtn = editCareTeam || addProvider || editProvider;
  const nextBtn = !saveNextBtn && (currentStage > teamStage);

  const careId = selectedPrgm.careplanId;
  const prgmName = selectedPrgm.abbrevation;

  useEffect(() => {
    handleTimer();
  }, [careId]);

  const handleTimer: () => void = () => {
    if (selectedPrgm.showLogTime) {
      if (timerStatus == 1) {
        dispatch(setTimerStatus({ status: 2, parentApiCall: true }));
      }
      if (prgmName == "RPM") dispatch(setRightHead("care-plan"));
    }
  }

  const handleTeamSaveNext: () => void = async () => {
    selectedPrgm &&
      dispatch(
        addSelectedPrgm({
          ...selectedPrgm,
          ...(selectedPrgm.careplanStage >
            PatientFormatter.GetCPStage(Stages.CPTeam)
            ? {}
            : {
              careplanState: Stages.CPShare,
              careplanStage: PatientFormatter.GetCPStage(Stages.CPShare),
            }),
        })
      );
    dispatch(setFormLoader(false));
    navigate(`../${RouteUrls.careSummary}`, { replace: true });
  };

  const handleNext: () => void = async () => {
    if (selectedPrgm.careplanStage < shareStage) {
      const res = await CarePlanApi.CPStateUpdate({
        data: { toState: Stages.CPShare },
        id1: careId,
      });
      if (res?.success) {
        dispatch(
          addSelectedPrgm({
            ...selectedPrgm,
            careplanState: Stages.CPShare,
            careplanStage: shareStage,
          })
        );
      }
    }
    navigate(`../${RouteUrls.careSummary}`, { replace: true });
  };

  return (
    <Box width="91%" sx={{ overflow: "auto", ...CommonStyle.sxWhiteCard }}>
      <Typography variant="body2" fontWeight="bold">
        Enrolled Program - {prgmName}
      </Typography>
      <ReusableCTUI
        addAddProviders={addProvider}
        displayNextBtn={nextBtn}
        displaySaveBtn={false}
        displaySaveNextBtn={saveNextBtn}
        editAddProviders={editProvider}
        editCareTeam={editCareTeam}
        filterForm1EmptyFields={false}
        filterForm2EmptyFields={false}
        openAllForSA={isAdmin}
        prgmDetails={selectedPrgm}
        handleNext={handleNext}
        handleSaveNext={handleTeamSaveNext}
      />
    </Box>
  );
};
export default CareTeam;
